/* eslint-disable react-hooks/rules-of-hooks */
import { ArrowLeft } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import Page from "src/components/Page";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { X } from "react-feather";

import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import moment from "moment";
import { getSetting } from "src/api/updateSetting";
import { Routes } from "src/constant/api_url";
import { getPaymentMethodApi } from "src/api/paymentMethodApi";
import CustomerInsertUpdateModal from "../Customer/CustomerInsertUpdateModal";
import { getProductApi } from "src/api/productApi";
import { invoiceToTypeOptions } from "src/constant/variable";
import {
  createInvoiceApi,
  fetchGstDetailsbynumberApi,
  getCustomerListForInvoiceApi,
  updateInvoiceApi,
  getStateListApi,
  getCityListByStateApi
} from "src/api/invoiceApi";
import { notification } from "src/utils/messages";
import { handleDownload } from "src/utils/common";

export default function AddInvoice() {
  const location = useLocation();
  const navigate = useNavigate();
  const formikRef = useRef();

  const [settingData, setSettingData] = useState({});
  const [customerList, setCustomerList] = useState([]);
  const [paymentMethodsList, setPaymentMethodsList] = useState([]);
  const [customerModal, setCustomerModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [invoiceToType, setInvoiceToType] = useState(
    location?.state?.mode == "edit" ? location?.state?.data?.i_to_type : 1
  );
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const toggleCustomerModal = () => setCustomerModal(!customerModal);
  const createInvoiceHandler = async (data) => {
    const finalData = {
      ...data,
      s_company_name: settingData?.company_name || "",
      s_company_mono: settingData?.company_mono || "",
      s_company_email: settingData?.company_email || "",
      s_company_logo: settingData?.company_logo || "",
      s_company_gst_no: settingData?.company_gst_no || "",
      s_company_address: settingData?.company_address || "",
      ac_holder_name: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_h_name : settingData?.i_gst_ac_h_name,
      branch_name: data?.company_gst_type == 0 ? settingData?.i_ngst_br_name : settingData?.i_gst_br_name,
      ac_type: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_type : settingData?.i_gst_ac_type,
      bank_name: data?.company_gst_type == 0 ? settingData?.i_ngst_b_name : settingData?.i_gst_b_name,
      ac_no: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_no : settingData?.i_gst_ac_no,
      ifsc_code: data?.company_gst_type == 0 ? settingData?.i_ngst_ifsc_code : settingData?.i_gst_ifsc_code,
      s_company_pan_no: settingData?.company_pan_no || "",
      s_company_website: settingData?.company_website || "",
      i_sign_img: data?.company_gst_type == 0 ? settingData?.i_ngst_sign : settingData?.i_gst_sign,
      i_type: location?.state?.data?.i_type,
      payment_date: moment(data?.payment_date).format("DD-MM-YYYY"),
      i_date: moment(data?.i_date).format("DD-MM-YYYY")
    };

    setLoading(true);

    const resp = await createInvoiceApi(finalData);
    if (resp.status == 1) {
      navigate(location?.state?.data?.i_type == 1 ? "/paid-invoice" : "/quotation-invoice");
    }
    setLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const updateInvoiceHandler = async (data) => {
    const finalData = {
      ...location?.state?.data,
      ...data,
      s_company_name: settingData?.company_name || "",
      s_company_mono: settingData?.company_mono || "",
      s_company_email: settingData?.company_email || "",
      s_company_logo: settingData?.company_logo || "",
      s_company_gst_no: settingData?.company_gst_no || "",
      s_company_address: settingData?.company_address || "",
      ac_holder_name: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_h_name : settingData?.i_gst_ac_h_name,
      branch_name: data?.company_gst_type == 0 ? settingData?.i_ngst_br_name : settingData?.i_gst_br_name,
      ac_type: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_type : settingData?.i_gst_ac_type,
      bank_name: data?.company_gst_type == 0 ? settingData?.i_ngst_b_name : settingData?.i_gst_b_name,
      ac_no: data?.company_gst_type == 0 ? settingData?.i_ngst_ac_no : settingData?.i_gst_ac_no,
      ifsc_code: data?.company_gst_type == 0 ? settingData?.i_ngst_ifsc_code : settingData?.i_gst_ifsc_code,
      s_company_pan_no: settingData?.company_pan_no || "",
      s_company_website: settingData?.company_website || "",
      i_sign_img: data?.company_gst_type == 0 ? settingData?.i_ngst_sign : settingData?.i_gst_sign,
      i_type: location?.state?.data?.i_type,
      i_date: moment(data?.i_date).format("DD-MM-YYYY"),
      c_name: data?.c_name || "",
      c_company_name: data?.c_company_name || "",
      c_mono: data?.c_mono || "",
      c_email: data?.c_email || "",
      c_company_gst_no: data?.gst_type == 0 ? "" : (data?.c_company_gst_no || ""),
      c_customer_address: data?.c_customer_address || "",
      c_company_pan_no: data?.c_company_pan_no || "",
      i_t_c: data?.i_t_c || "",
      remarks: data?.remarks || "",
      payment_date: moment(data?.payment_date).format("DD-MM-YYYY") || "",
      i_id: location?.state?.data?.i_id || 0
    };

    setLoading(true);

    const resp = await updateInvoiceApi(finalData);
    if (resp.status == 1) {
      navigate(location?.state?.data?.i_type == 1 ? "/paid-invoice" : "/quotation-invoice");
    }
    setLoading(false);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
  };

  const determineGstType = (customerGst, stateId, gstType) => {
    const companyGst = settingData?.company_gst_no || "";
    if (companyGst && customerGst && customerGst.length >= 2 && gstType == 1) {
      const companyState = companyGst.substring(0, 2);
      const customerState = customerGst.substring(0, 2);
      return companyState === customerState ? 2 : 1;
    } else if (stateId == 1) {
      return 2;
    } else {
      return 1;
    }
  };

  const changeCompanyDetails = (gstType, currentValues, setFieldValue) => {
    if (gstType == 1) {
      setFieldValue("c_company_name", currentValues.gst_business_name);
      setFieldValue("c_customer_address", currentValues.gst_business_address);
    } else {
      setFieldValue("c_company_name", currentValues.n_gst_business_name);
      setFieldValue("c_customer_address", currentValues.n_gst_business_address);
    }
  }

  const applyGstType = (gstType, currentValues, setFieldValue) => {
    setFieldValue(
      "i_t_c",
      currentValues?.company_gst_type == 0 ? settingData?.i_ngst_t_c : settingData?.i_gst_t_c,
      false
    );

    // build updated products using calculateRow
    const updatedProducts = currentValues.invoice_product.map((item, index) => {
      let updatedItem = { ...item };

      if (gstType == 1) {
        updatedItem.i_d_igst_per = settingData?.i_gst_per || 18;
        updatedItem.i_d_sgst_per = 0;
        updatedItem.i_d_cgst_per = 0;
      } else if (gstType == 2) {
        updatedItem.i_d_igst_per = 0;
        updatedItem.i_d_sgst_per = Number(settingData?.i_gst_per || 18) / 2;
        updatedItem.i_d_cgst_per = Number(settingData?.i_gst_per || 18) / 2;
      } else {
        updatedItem.i_d_igst_per = 0;
        updatedItem.i_d_sgst_per = 0;
        updatedItem.i_d_cgst_per = 0;
      }

      // reuse calculation logic (batch mode)
      return calculateRow(
        index,
        updatedItem,
        { ...currentValues, gst_type: gstType },
        setFieldValue,
        true,
        currentValues
      );
    });

    // single totals update
    updateTotals(updatedProducts, currentValues.company_gst_type, gstType, setFieldValue, currentValues);
  };

  const calculateRow = (index, updatedItem, values, setFieldValue, skipUpdate = false) => {
    const isGstEnabled = values.company_gst_type === 1;
    const inclusive = values.inclusive_gst == 1;
    let effectiveGstType = 0;
    if (isGstEnabled) {
      effectiveGstType = determineGstType(values.c_company_gst_no, values.state_id, values.gst_type);
    }

    let cost = Number(updatedItem?.i_d_cost || 0);

    if (isGstEnabled && inclusive) {
      const perPic = Number(updatedItem?.i_per_pic || 0);
      if (perPic > 0) {
        if (effectiveGstType == 1) {
          const rate = Number(updatedItem?.i_d_igst_per || 0);
          cost = (perPic * 100) / (100 + rate);
        } else if (effectiveGstType == 2) {
          const sRate = Number(updatedItem?.i_d_sgst_per || 0);
          const cRate = Number(updatedItem?.i_d_cgst_per || 0);
          const totalRate = sRate + cRate;
          cost = (perPic * 100) / (100 + totalRate);
        }
      }
    }

    let totalAmount = Number(updatedItem?.i_d_qty || 1) * cost;
    let discount = Number(updatedItem?.i_d_discount_amt || 0);
    let taxable = totalAmount - discount;

    let igst = 0,
      sgst = 0,
      cgst = 0;

    if (isGstEnabled) {
      if (effectiveGstType == 1) {
        const rate = Number(updatedItem?.i_d_igst_per || 0);
        igst = (taxable * rate) / 100;
      } else if (effectiveGstType == 2) {
        const sRate = Number(updatedItem?.i_d_sgst_per || 0);
        const cRate = Number(updatedItem?.i_d_cgst_per || 0);

        sgst = (taxable * sRate) / 100;
        cgst = (taxable * cRate) / 100;
      }
    }

    const taxAmount = igst + sgst + cgst;
    const total = taxable + taxAmount;

    const newItem = {
      ...updatedItem,
      i_d_cost: cost,
      tax_amount: taxAmount.toFixed(2),
      i_d_igst_amt: igst.toFixed(2),
      i_d_sgst_amt: sgst.toFixed(2),
      i_d_cgst_amt: cgst.toFixed(2),
      i_d_sub_amt: taxable.toFixed(2),
      i_d_total_amt: total.toFixed(2)
    };

    if (skipUpdate) return newItem;

    const updatedProducts = [...values.invoice_product];
    updatedProducts[index] = newItem;

    updateTotals(updatedProducts, values.company_gst_type, values.gst_type, setFieldValue, values);
  };

  const updateTotals = (products, companyGstType, gst_type, setFieldValue, values) => {
    let subTotal = 0;
    let totalDiscount = 0;
    let totalIGST = 0;
    let totalSGST = 0;
    let totalCGST = 0;
    let totalTaxAmount = 0;

    const isGstEnabled = companyGstType === 1;
    let effectiveGstType = 0;
    if (isGstEnabled) {
      effectiveGstType = determineGstType(values.c_company_gst_no, values.state_id, values.gst_type);
    }

    products.forEach((item) => {
      const amt = Number(item.i_d_qty || 1) * Number(item.i_d_cost || 0);
      const disc = Number(item.i_d_discount_amt || 0);

      const igst = isGstEnabled ? Number(item.i_d_igst_amt || 0) : 0;
      const sgst = isGstEnabled ? Number(item.i_d_sgst_amt || 0) : 0;
      const cgst = isGstEnabled ? Number(item.i_d_cgst_amt || 0) : 0;

      subTotal += amt;
      totalDiscount += disc;
      totalIGST += igst;
      totalSGST += sgst;
      totalCGST += cgst;
      totalTaxAmount += igst + sgst + cgst;
    });

    const finalTotal = subTotal - totalDiscount + totalTaxAmount;

    setFieldValue("invoice_product", products, false);

    setFieldValue("i_subtotal_amt", subTotal.toFixed(2), false);
    setFieldValue("i_discount_amt", totalDiscount.toFixed(2), false);

    if (isGstEnabled) {
      if (effectiveGstType == 1) {
        setFieldValue("i_igst_amt", totalIGST.toFixed(2), false);
        setFieldValue("i_sgst_amt", "0.00", false);
        setFieldValue("i_cgst_amt", "0.00", false);
      } else if (effectiveGstType == 2) {
        setFieldValue("i_igst_amt", "0.00", false);
        setFieldValue("i_sgst_amt", totalSGST.toFixed(2), false);
        setFieldValue("i_cgst_amt", totalCGST.toFixed(2), false);
      }
    } else {
      setFieldValue("i_igst_amt", "0.00", false);
      setFieldValue("i_sgst_amt", "0.00", false);
      setFieldValue("i_cgst_amt", "0.00", false);
    }

    setFieldValue("i_total_amt", finalTotal.toFixed(2), false);
    setFieldValue("payment_amount", finalTotal.toFixed(2), false);
  };

  const handleRowChange = (index, field, value, values, setFieldValue) => {
    const updatedItem = {
      ...values.invoice_product[index],
      [field]: value
    };

    setFieldValue(`invoice_product.${index}`, updatedItem, false);

    calculateRow(index, updatedItem, values, setFieldValue);
  };

  const validationSchema = Yup.object({
    i_to_id: Yup.number().moreThan(-1, "Customer is required").required("Customer is required"),
    c_name: Yup.string()
      .trim()
      .required("Customer Name is required")
      .min(1, "Customer Name is required"),
    c_mono: Yup.string()
      .trim()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
    c_email: Yup.string().trim().email("Enter a valid email address"),
    c_company_gst_no: Yup.string().when("gst_type", {
      is: (val) => val === 1 || val === 2,
      then: (schema) =>
        schema
          .trim()
          .required("GST number is required")
          .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
            "Enter valid GST number"
          ),
      otherwise: (schema) => schema.notRequired()
    }),
    state_id: Yup.string().required("State is required"),
    city_id: Yup.string().required("City is required"),
    p_m_id: Yup.number().moreThan(0, "Payment method is required").required("Payment method is required"),

    invoice_product: Yup.array().of(
      Yup.object().shape({
        i_p_id: Yup.number().min(1).required("Item is required")
      })
    )
  });

  async function getSettingData() {
    try {
      const resp = await getSetting();
      if (resp.status == 1) {
        setSettingData(resp.data);
      }
    } catch { }
  }

  async function getCustomerListForInvoice(data) {
    setLoading(true);

    try {
      const resp = await getCustomerListForInvoiceApi({
        page: data?.pageNo,
        per_page: 20,
        i_to_type: invoiceToType,
        search: data?.searchText,
        i_to_id: data?.i_to_id || undefined
      });

      if (resp.status == 1) {
        if (data?.pageNo == 1) setCustomerList(resp.data);
        else setCustomerList([...customerList, ...resp.data]);
        setHasMore(resp?.data.length === 20);
        setPage(data?.pageNo);
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }

  useEffect(() => {
    setCustomerList([]);
    setPage(1);
    setHasMore(true);
    setSearch("");
    getCustomerListForInvoice({
      pageNo: 1,
      searchText: "",
      i_to_id: location?.state?.mode == "edit" ? location?.state?.data?.i_to_id : undefined
    });
  }, [invoiceToType]);

  async function getPaymentMethodsList() {
    try {
      const resp = await getPaymentMethodApi();
      if (resp.status == 1) {
        setPaymentMethodsList(resp.data);
      }
    } catch { }
  }

  useEffect(() => {
    getSettingData();
    getProductMethod();
    getPaymentMethodsList();
    getStateList();
  }, []);

  const getStateList = async () => {
    try {
      const resp = await getStateListApi();
      if (resp.status == 1) {
        setStateList(resp.data);
      }
    } catch (error) { }
  };

  const getCityList = async (stateId, setFieldValue) => {
    try {
      const resp = await getCityListByStateApi({ state_id: stateId });
      if (resp.status == 1) {
        setCityList(resp.data);
      }
    } catch (error) { }
  };

  const getProductMethod = async () => {
    const resp = await getProductApi({ i_p_type: -1 });
    if (resp.status == 1) {
      setProductData(resp?.data);
    }
  };

  useEffect(() => {
    formikRef.current.setFieldValue(
      "i_t_c",
      location?.state?.mode == "edit"
        ? location?.state?.data?.i_t_c
        : formikRef.current.values.company_gst_type == 0
          ? settingData?.i_ngst_t_c
          : settingData?.i_gst_t_c
    );
    if (location?.state?.mode == "edit") {
      formikRef.current.setFieldValue("invoice_product", location?.state?.data?.invoice_product);
    }
  }, [settingData]);

  useEffect(() => {
    if (location?.state?.mode == "edit" && location?.state?.data?.state_id) {
      getCityList(location?.state?.data?.state_id);
    }
  }, [location?.state]);

  const calculateTaxTotal = (item) => {
    const cgst = parseFloat(item?.i_d_cgst_amt) || 0;
    const sgst = parseFloat(item?.i_d_sgst_amt) || 0;
    const igst = parseFloat(item?.i_d_igst_amt) || 0;

    const total = cgst + sgst + igst;

    return Number(total.toFixed(2)); // keeps decimal precision
  };

  const fetchGstDetailsbynumber = async (setFieldValue, gst_no) => {
    try {
      const response = await fetchGstDetailsbynumberApi({ gst_no: gst_no });

      if (response?.status === 1) {
        setFieldValue("c_customer_address", response?.data?.address);
        setFieldValue("c_company_name", response?.data?.business_name);
      }

      let notify = notification({
        type: response.status == 0 ? "error" : "success",
        message: response.message
      });
      notify();
    } catch (error) {
      notification({
        type: "error",
        message: "Failed to fetch GST details"
      })();
    }
  };

  return (
    <>
      <Page
        title={`${location?.state?.data?.i_type === 0 ? "Quotation" : "Invoice"} ${location?.state?.mode == "edit" ? "Edit" : "Add"
          }`}
      >
        <Stack mb={1} direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
          <Typography variant="h4" gutterBottom>
            {location?.state?.mode == "edit" ? "Edit" : "Add"}{" "}
            {location?.state?.data?.i_type === 0 ? "Quotation" : "Invoice"}
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              navigate(location?.state?.data?.i_type == 1 ? "/paid-invoice" : "/quotation-invoice");
            }}
          >
            <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
            Back
          </Button>
        </Stack>

        <Card sx={{ padding: 3, borderRadius: 1 }}>
          <Formik
            innerRef={formikRef}
            enableReinitialize={false}
            initialValues={{
              i_to_id: location?.state?.mode == "edit" ? location?.state?.data?.i_to_id : -1,
              i_to_type: location?.state?.mode == "edit" ? location?.state?.data?.i_to_type : 1,
              i_date:
                location?.state?.mode == "edit"
                  ? moment(location?.state?.data?.i_date, "DD-MM-YYYY").toDate()
                  : new Date(),
              c_company_name:
                location?.state?.mode == "edit" ? location?.state?.data?.c_company_name : "",
              c_name: location?.state?.mode == "edit" ? location?.state?.data?.c_name : "",
              c_mono: location?.state?.mode == "edit" ? location?.state?.data?.c_mono : "",
              c_email: location?.state?.mode == "edit" ? location?.state?.data?.c_email : "",
              c_company_gst_no:
                location?.state?.mode == "edit" ? location?.state?.data?.c_company_gst_no : "",
              c_customer_address:
                location?.state?.mode == "edit" ? location?.state?.data?.c_customer_address : "",
              c_company_pan_no:
                location?.state?.mode == "edit" ? location?.state?.data?.c_company_pan_no : "",
              state_id: location?.state?.mode == "edit" ? location?.state?.data?.state_id : "",
              city_id: location?.state?.mode == "edit" ? location?.state?.data?.city_id : "",
              company_gst_type:
                location?.state?.mode == "edit" ? location?.state?.data?.company_gst_type : 1,
              gst_type: location?.state?.mode == "edit" ? location?.state?.data?.gst_type : 0,
              inclusive_gst:
                location?.state?.mode == "edit" ? location?.state?.data?.inclusive_gst : 0,
              payment_date:
                location?.state?.mode == "edit"
                  ? moment(location?.state?.data?.payment_date, "DD-MM-YYYY").toDate()
                  : new Date(),
              p_m_id: location?.state?.mode == "edit" ? location?.state?.data?.p_m_id : -1,
              i_subtotal_amt:
                location?.state?.mode == "edit" ? location?.state?.data?.i_subtotal_amt : "0",
              i_discount_amt:
                location?.state?.mode == "edit" ? location?.state?.data?.i_discount_amt : "0",
              i_igst_amt: location?.state?.mode == "edit" ? location?.state?.data?.i_igst_amt : "0",
              i_sgst_amt: location?.state?.mode == "edit" ? location?.state?.data?.i_sgst_amt : "0",
              i_cgst_amt: location?.state?.mode == "edit" ? location?.state?.data?.i_cgst_amt : "0",
              i_total_amt:
                location?.state?.mode == "edit" ? location?.state?.data?.i_total_amt : "0",
              remarks: location?.state?.mode == "edit" ? location?.state?.data?.remarks : "",
              gst_business_name: location?.state?.mode == "edit" ? location?.state?.data?.i_gst_business_name : "",
              gst_business_address: location?.state?.mode == "edit" ? location?.state?.data?.i_gst_business_address : "",
              n_gst_business_name: location?.state?.mode == "edit" ? location?.state?.data?.c_company_name : "",
              n_gst_business_address: location?.state?.mode == "edit" ? location?.state?.data?.c_customer_address : "",
              i_t_c:
                location?.state?.mode == "edit"
                  ? location?.state?.data?.i_t_c
                  : formikRef?.current?.values?.company_gst_type == 0
                    ? settingData?.i_ngst_t_c
                    : settingData?.i_gst_t_c,
              invoice_product: [
                {
                  i_p_id: "",
                  i_d_hsn_code: "",
                  i_d_cost: "0",
                  i_d_qty: 1,
                  i_d_discount_amt: "0",
                  i_d_sub_amt: "0",
                  i_d_igst_amt: "0",
                  i_d_sgst_amt: "0",
                  i_d_cgst_amt: "0",
                  i_d_igst_per: settingData?.i_gst_per || 18,
                  i_d_sgst_per: (settingData?.i_gst_per || 18) / 2,
                  i_d_cgst_per: (settingData?.i_gst_per || 18) / 2,
                  i_d_total_amt: "0",
                  i_d_description: "",
                  i_per_pic: "0"
                }
              ]
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              location?.state?.mode == "edit"
                ? updateInvoiceHandler(values)
                : createInvoiceHandler(values);
            }}
          >
            {({ values, setFieldValue, errors, touched, setFieldTouched }) => {
              React.useEffect(() => {
                if (values.city_id && cityList.length > 0) {
                  const matchedCity = cityList.find((c) => c.city_id == values.city_id);
                  if (matchedCity) {
                    setFieldValue("remarks", matchedCity.city_name.toUpperCase());
                  }
                } else if (!values.city_id) {
                  setFieldValue("remarks", "");
                }
              }, [values.city_id, cityList]);

              return (
              <>
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                      <div>
                        <Box
                          sx={{
                            width: 140,
                            height: 150,
                            border: "1px dashed #ccc",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            backgroundColor: "#fafafa",
                            boxShadow: 1,
                            p: 1
                          }}
                        >
                          {settingData?.company_logo ? (
                            <img
                              src={`${Routes.API_HOSTNAME}invoice-setting/${settingData?.company_logo}`}
                              alt="Company Logo"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"
                              }}
                            />
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              No Logo
                            </Typography>
                          )}
                        </Box>
                      </div>

                      <div className="mt-15">
                        <div style={{ display: "flex", gap: "45px" }}>
                          <p>Name:</p>
                          <p>{settingData?.company_name}</p>
                        </div>
                        <div style={{ display: "flex", gap: "41px" }}>
                          <p>Mo No:</p>
                          <p>{settingData?.company_mono}</p>
                        </div>
                        <div style={{ display: "flex", gap: "48px" }}>
                          <p>Email:</p>
                          <p>{settingData?.company_email}</p>
                        </div>
                        <div style={{ display: "flex", gap: "28px" }}>
                          <p>Address:</p>
                          <p>{settingData?.company_address}</p>
                        </div>

                        <div className="mt-15">
                          <Typography
                            variant="subtitle1"
                            fontWeight={700}
                            sx={{ marginBottom: "10px" }}
                          >
                            Company GST Type
                          </Typography>
                          <Field name="company_gst_type">
                            {({ field, form }) => (
                              <RadioGroup
                                {...field}
                                row
                                value={values.company_gst_type === 0 ? "0" : "1"}
                                onChange={(e) => {
                                  const val = Number(e.target.value);
                                  form.setFieldValue("company_gst_type", val);
                                  form.setFieldValue(
                                    "i_t_c",
                                    val == 0 ? settingData?.i_ngst_t_c : settingData?.i_gst_t_c
                                  );

                                  // Reset or apply GST based on the new selection
                                  if (val === 1) {
                                    const newGstType = determineGstType(values.c_company_gst_no, values.state_id, values.gst_type);
                                    applyGstType(newGstType, values, setFieldValue);
                                  } else {
                                    applyGstType(0, values, setFieldValue);
                                  }
                                }}
                              >
                                <FormControlLabel
                                  value="0"
                                  control={<Radio />}
                                  label="Without GST"
                                />
                                <FormControlLabel value="1" control={<Radio />} label="With GST" />
                              </RadioGroup>
                            )}
                          </Field>
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={6}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: { xs: 5, sm: 0 }
                      }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          name="i_date"
                          label="Date "
                          inputFormat="dd/MM/yyyy"
                          value={values.i_date || null}
                          onChange={(newDate) => {
                            setFieldValue("i_date", newDate || null);
                            setFieldValue("payment_date", newDate || null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              sx={{
                                width: {
                                  xs: "100%",
                                  sm: "auto"
                                }
                              }}
                            />
                          )}
                          disabled={location?.state?.mode == "edit"}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                  <hr style={{ margin: "25px 0" }} />
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle1"
                            fontWeight={700}
                            sx={{ marginBottom: "25px" }}
                          >
                            Invoice To
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Select
                            options={invoiceToTypeOptions}
                            value={
                              invoiceToTypeOptions.find(
                                (option) => option.value === values.i_to_type
                              ) || null
                            }
                            isDisabled={location?.state?.mode === "edit"}
                            onChange={(selectedOption) => {
                              const value = selectedOption ? Number(selectedOption.value) : "";

                              setInvoiceToType(value);
                              setFieldValue("i_to_type", value);

                              setFieldValue("i_to_id", -1);
                              setFieldValue("c_company_name", "");
                              setFieldValue("c_name", "");
                              setFieldValue("c_mono", "");
                              setFieldValue("c_email", "");
                              setFieldValue("c_customer_address", "");
                              setFieldValue("c_company_gst_no", "");
                            }}
                            onBlur={() => setFieldTouched("i_to_type", true)}
                            menuPortalTarget={document.body}
                          />
                          {touched.i_to_type && errors.i_to_type && (
                            <p
                              style={{
                                color: "#d32f2f",
                                fontSize: "0.75rem",
                                margin: "3px 0px 0"
                              }}
                            >
                              {errors.i_to_type}
                            </p>
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Select
                            options={[
                              ...(values?.i_to_type == 1
                                ? [
                                  {
                                    label: "+ Add New Customer",
                                    value: "add_new_customer",
                                    isAddNew: true
                                  }
                                ]
                                : []),

                              ...(customerList || []).map((cust) => ({
                                label: cust?.c_name,
                                value: cust?.c_id
                              }))
                            ]}
                            isDisabled={location?.state?.mode === "edit"}
                            value={
                              customerList
                                ?.map((cust) => ({
                                  label: cust?.c_name,
                                  value: cust?.c_id
                                }))
                                ?.find((option) => option.value === values.i_to_id) || null
                            }
                            onChange={(selectedOption) => {
                              if (selectedOption.value == "add_new_customer") {
                                toggleCustomerModal();
                                return;
                              }
                              setFieldValue("i_to_id", selectedOption ? selectedOption.value : -1);

                              const selectedCustomer = customerList?.find(
                                (cust) => cust?.c_id == selectedOption?.value
                              );

                              setFieldValue("c_company_name", selectedCustomer?.c_company_name);
                              setFieldValue("c_name", selectedCustomer?.c_name);
                              setFieldValue("c_mono", selectedCustomer?.c_mono);
                              setFieldValue("c_email", selectedCustomer?.c_email);
                              setFieldValue("c_customer_address", selectedCustomer?.c_address);
                              setFieldValue("state_id", selectedCustomer?.state_id || "");
                              setFieldValue("city_id", selectedCustomer?.city_id || "");
                              setFieldValue("c_company_gst_no", selectedCustomer?.c_gst_no || "");
                              if (values?.i_to_type == 0) {
                                setFieldValue("gst_business_name", selectedCustomer?.i_gst_business_name || "");
                                setFieldValue("gst_business_address", selectedCustomer?.i_gst_business_address || "");
                                setFieldValue("n_gst_business_name", selectedCustomer?.c_company_name || "");
                                setFieldValue("n_gst_business_address", selectedCustomer?.c_customer_address || "");
                                if (selectedCustomer?.c_gst_no !== undefined && selectedCustomer?.c_gst_no !== null && selectedCustomer?.c_gst_no !== '') {
                                  setFieldValue("gst_type", 1);
                                  setFieldValue("c_company_name", selectedCustomer?.i_gst_business_name);
                                  setFieldValue("c_customer_address", selectedCustomer?.i_gst_business_address);
                                } else {
                                  changeCompanyDetails(values.gst_type, {
                                    gst_business_name: selectedCustomer?.i_gst_business_name,
                                    gst_business_address: selectedCustomer?.i_gst_business_address,
                                    n_gst_business_name: selectedCustomer?.c_company_name,
                                    n_gst_business_address: selectedCustomer?.c_customer_address
                                  }, setFieldValue);
                                }
                              }
                              if (selectedCustomer?.state_id) {
                                getCityList(selectedCustomer?.state_id, setFieldValue);
                              }
                            }}
                            onInputChange={(inputValue, { action }) => {
                              if (action === "input-change") {
                                setSearch(inputValue);
                                if (hasMore && !loading) {
                                  getCustomerListForInvoice({
                                    pageNo: 1,
                                    searchText: inputValue
                                  });
                                }
                              }
                            }}
                            onMenuScrollToBottom={() => {
                              if (hasMore && !loading) {
                                const nextPage = page + 1;
                                getCustomerListForInvoice({
                                  pageNo: nextPage,
                                  searchText: search
                                });
                              }
                            }}
                            isLoading={loading}
                            onBlur={() => setFieldTouched("i_to_id", true)}
                            menuPortalTarget={document.body}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                color:
                                  state.data.value === "add_new_customer" ? "#1976d2" : base.color,
                                fontWeight: state.data.value === "add_new_customer" ? 600 : 400,
                                backgroundColor: state.isFocused
                                  ? state.data.value === "add_new_customer"
                                    ? "#e3f2fd"
                                    : base.backgroundColor
                                  : base.backgroundColor,
                                cursor: "pointer"
                              }),
                              control: (base, state) => ({
                                ...base,
                                borderColor:
                                  touched.i_to_id && errors.i_to_id ? "#d32f2f" : base.borderColor,
                                boxShadow:
                                  touched.i_to_id && errors.i_to_id
                                    ? "0 0 0 1px #d32f2f"
                                    : state.isFocused
                                      ? base.boxShadow
                                      : "none",
                                "&:hover": {
                                  borderColor:
                                    touched.i_to_id && errors.i_to_id ? "#d32f2f" : base.borderColor
                                }
                              }),
                              menuPortal: (base) => ({
                                ...base,

                                zIndex: 9999
                              })
                            }}
                          />
                          {touched.i_to_id && errors.i_to_id && (
                            <p
                              style={{
                                color: "#d32f2f",
                                fontSize: "0.75rem",
                                margin: "3px 0px 0"
                              }}
                            >
                              {errors.i_to_id}
                            </p>
                          )}
                        </Grid>
                        {values?.i_to_id != -1 && (
                          <>
                            <Grid item xs={12}>
                              <Field name="c_company_name">
                                {({ field, form }) => (
                                  <TextField
                                    {...field}
                                    size="small"
                                    label="Customer Company Name"
                                    autoComplete="off"
                                    fullWidth
                                    onBlur={(e) => {
                                      form.setFieldValue(field.name, field.value.trim());
                                      field.onBlur(e);
                                    }}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Field name="c_name">
                                {({ field, form }) => (
                                  <TextField
                                    {...field}
                                    size="small"
                                    label="Customer Name"
                                    autoComplete="off"
                                    fullWidth
                                    error={Boolean(form.touched.c_name && form.errors.c_name)}
                                    helperText={form.touched.c_name && form.errors.c_name}
                                    onBlur={(e) => {
                                      form.setFieldValue(field.name, field.value.trim());
                                      field.onBlur(e);
                                    }}
                                    sx={{
                                      "& .MuiFormHelperText-root": {
                                        textAlign: "left",
                                        marginLeft: 0,
                                        marginRight: 0
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Field name="c_mono">
                                {({ field, form }) => (
                                  <TextField
                                    {...field}
                                    size="small"
                                    label="Customer Mobile Number"
                                    autoComplete="off"
                                    fullWidth
                                    error={Boolean(form.touched.c_mono && form.errors.c_mono)}
                                    helperText={form.touched.c_mono && form.errors.c_mono}
                                    inputProps={{
                                      maxLength: 10,
                                      inputMode: "numeric",
                                      pattern: "[0-9]*"
                                    }}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, "");
                                      form.setFieldValue(field.name, value);
                                    }}
                                    sx={{
                                      "& .MuiFormHelperText-root": {
                                        textAlign: "left",
                                        marginLeft: 0,
                                        marginRight: 0
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Field name="c_email">
                                {({ field, form }) => (
                                  <TextField
                                    {...field}
                                    size="small"
                                    label="Customer Email"
                                    autoComplete="off"
                                    fullWidth
                                    error={Boolean(form.touched.c_email && form.errors.c_email)}
                                    helperText={form.touched.c_email && form.errors.c_email}
                                    onBlur={(e) => {
                                      form.setFieldValue(field.name, field.value.trim());
                                      field.onBlur(e);
                                    }}
                                    sx={{
                                      "& .MuiFormHelperText-root": {
                                        textAlign: "left",
                                        marginLeft: 0,
                                        marginRight: 0
                                      }
                                    }}
                                  />
                                )}
                              </Field>
                            </Grid>
                            {values?.gst_type != 0 && (
                              <>
                                <Grid item xs={12} md={6}>
                                  <Field name="c_company_gst_no">
                                    {({ field, form }) => (
                                      <TextField
                                        {...field}
                                        size="small"
                                        label="Customer GST No"
                                        autoComplete="off"
                                        fullWidth
                                        error={Boolean(
                                          form.touched.c_company_gst_no &&
                                          form.errors.c_company_gst_no
                                        )}
                                        helperText={
                                          form.touched.c_company_gst_no &&
                                          form.errors.c_company_gst_no
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value.toUpperCase();
                                          form.setFieldValue(field.name, value);

                                          // Automatically update GST type if "With GST" is selected at the top
                                          if (values.company_gst_type === 1) {
                                            const newGstType = determineGstType(value, values.state_id, values.gst_type);
                                            if (newGstType !== values.gst_type) {
                                              applyGstType(newGstType, values, setFieldValue);
                                            }
                                          }
                                        }}
                                        onBlur={(e) => {
                                          form.setFieldValue(field.name, field.value.trim());
                                          field.onBlur(e);
                                        }}
                                        sx={{
                                          "& .MuiFormHelperText-root": {
                                            textAlign: "left",
                                            marginLeft: 0,
                                            marginRight: 0
                                          }
                                        }}
                                      />
                                    )}
                                  </Field>
                                </Grid>
                              </>
                            )}

                            <Grid item xs={12}>
                              <Field name="c_customer_address">
                                {({ field, form }) => (
                                  <TextField
                                    {...field}
                                    size="small"
                                    label="Customer Address"
                                    autoComplete="off"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    onBlur={(e) => {
                                      form.setFieldValue(field.name, field.value.trim());
                                      field.onBlur(e);
                                    }}
                                  />
                                )}
                              </Field>
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label>State</label>
                              <Select
                                options={stateList?.map((s) => ({
                                  label: s?.state_name,
                                  value: s?.state_id
                                }))}
                                value={
                                  stateList
                                    ?.map((s) => ({
                                      label: s?.state_name,
                                      value: s?.state_id
                                    }))
                                    ?.find((option) => option.value == values.state_id) || null
                                }
                                onChange={(selectedOption) => {
                                  setFieldValue("state_id", selectedOption ? selectedOption.value : "");
                                  setFieldValue("city_id", "");
                                  setCityList([]);
                                  if (selectedOption) {
                                    if (values.company_gst_type === 1) {
                                      const newGstType = determineGstType(values.c_company_gst_no, selectedOption ? selectedOption.value : "", values.gst_type);
                                      if (newGstType !== values.gst_type) {
                                        applyGstType(newGstType, values, setFieldValue);
                                      }
                                    } else {
                                      applyGstType(0, values, setFieldValue);
                                    }
                                    getCityList(selectedOption.value, setFieldValue);
                                  }
                                }}
                                onBlur={() => setFieldTouched("state_id", true)}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  control: (base) => ({
                                    ...base,
                                    borderColor:
                                      touched.state_id && errors.state_id ? "#d32f2f" : base.borderColor
                                  })
                                }}
                              />
                              {touched.state_id && errors.state_id && (
                                <p
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "0.75rem",
                                    margin: "3px 14px 0"
                                  }}
                                >
                                  {errors.state_id}
                                </p>
                              )}
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <label>City</label>
                              <Select
                                options={cityList?.map((c) => ({
                                  label: c?.city_name,
                                  value: c?.city_id
                                }))}
                                value={
                                  cityList
                                    ?.map((c) => ({
                                      label: c?.city_name,
                                      value: c?.city_id
                                    }))
                                    ?.find((option) => option.value == values.city_id) || null
                                }
                                onChange={(selectedOption) => {
                                  setFieldValue("city_id", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={() => setFieldTouched("city_id", true)}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  control: (base) => ({
                                    ...base,
                                    borderColor:
                                      touched.city_id && errors.city_id ? "#d32f2f" : base.borderColor
                                  })
                                }}
                              />
                              {touched.city_id && errors.city_id && (
                                <p
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "0.75rem",
                                    margin: "3px 14px 0"
                                  }}
                                >
                                  {errors.city_id}
                                </p>
                              )}
                            </Grid>

                            {values?.gst_type != 0 && (
                              <Grid item xs={12}>
                                <Box>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ mt: 1 }}
                                    onClick={() =>
                                      fetchGstDetailsbynumber(
                                        setFieldValue,
                                        values?.c_company_gst_no || ""
                                      )
                                    }
                                    disabled={
                                      !values?.c_company_gst_no ||
                                      values?.c_company_gst_no.length !== 15
                                    }
                                  >
                                    Verify GST No
                                  </Button>
                                </Box>
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12} md={12}>
                        <Typography
                          variant="subtitle1"
                          fontWeight={700}
                          sx={{ marginBottom: "25px" }}
                        >
                          Payment Details
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div>
                          <div style={{ display: "flex", gap: "21px" }}>
                            <p>Bank name:</p>
                            <p>
                              {values?.company_gst_type == 0
                                ? settingData?.i_ngst_b_name
                                : settingData?.i_gst_b_name}
                            </p>
                          </div>
                          <div style={{ display: "flex", gap: "17px" }}>
                            <p>Account No:</p>
                            <p>
                              {" "}
                              {values?.company_gst_type == 0
                                ? settingData?.i_ngst_ac_no
                                : settingData?.i_gst_ac_no}
                            </p>
                          </div>
                          <div style={{ display: "flex", gap: "26px" }}>
                            <p>IFSC Code:</p>
                            <p>
                              {" "}
                              {values?.company_gst_type == 0
                                ? settingData?.i_ngst_ifsc_code
                                : settingData?.i_gst_ifsc_code}
                            </p>
                          </div>
                          {values?.company_gst_type != 0 && (
                            <>
                              <div style={{ display: "flex", gap: "47px" }}>
                                <p>GST No:</p>
                                <p>{settingData?.company_gst_no}</p>
                              </div>
                            </>
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <hr style={{ margin: "25px 0" }} />
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={12}>
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle1"
                          fontWeight={700}
                          sx={{ marginBottom: "10px" }}
                        >
                          GST Type
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Field name="gst_type">
                          {({ field, form }) => (
                            <RadioGroup
                              {...field}
                              row
                              value={values.gst_type === 0 ? "0" : "1"}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                setFieldValue("gst_type", val);
                                if (values.company_gst_type == 1) {
                                  const newGstType = determineGstType(values.c_company_gst_no, values.state_id, val);
                                  applyGstType(newGstType, values, setFieldValue);
                                } else {
                                  applyGstType(0, values, setFieldValue);
                                }
                                if (values.i_to_type == 0) {
                                  changeCompanyDetails(val, values, setFieldValue);
                                }
                              }}
                            >
                              <FormControlLabel value="0" control={<Radio />} label="Without GST" />
                              <FormControlLabel value="1" control={<Radio />} label="With GST" />
                            </RadioGroup>
                          )}
                        </Field>
                      </Grid>
                      {values?.company_gst_type === 1 && (
                        <>
                          <Grid item xs={12} sx={{ marginTop: 3 }}>
                            <Stack direction="row" alignItems={"center"}>
                              <label>Inclusive GST</label>
                              <Switch
                                name="inclusive_gst"
                                checked={values.inclusive_gst === 1}
                                onChange={(e) => {
                                  const inclusive = e.target.checked ? 1 : 0;

                                  setFieldValue("inclusive_gst", inclusive, false);

                                  const updatedProducts = values.invoice_product.map(
                                    (item, index) => {
                                      let updatedItem = { ...item };
                                      if (inclusive == 1) {
                                        // Turning ON: base cost becomes inclusive price
                                        updatedItem.i_per_pic = Number(item.i_d_cost || 0).toString();
                                      } else {
                                        // Turning OFF: inclusive price becomes base cost
                                        updatedItem.i_d_cost = Number(item.i_per_pic || 0).toString();
                                        updatedItem.i_per_pic = "0";
                                      }

                                      return calculateRow(
                                        index,
                                        updatedItem,
                                        { ...values, inclusive_gst: inclusive },
                                        setFieldValue,
                                        true
                                      );
                                    }
                                  );

                                  // 🔥 update totals once
                                  updateTotals(
                                    updatedProducts,
                                    values.company_gst_type,
                                    values.gst_type,
                                    setFieldValue,
                                    values
                                  );
                                }}
                              />
                            </Stack>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>
                  <hr style={{ margin: "25px 0" }} />

                  <FieldArray name="invoice_product">
                    {({ push, remove }) => (
                      <>
                        {values.invoice_product.map((item, index) => (
                          <>
                            <Stack key={index}>
                              <Box
                                key={index}
                                sx={{
                                  position: "relative",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  padding: "16px",
                                  paddingRight: "48px",
                                  marginBottom: "25px"
                                }}
                              >
                                <Button
                                  size="small"
                                  color="error"
                                  variant="contained"
                                  sx={{
                                    position: "absolute",
                                    top: 12,
                                    right: 12,
                                    minWidth: "auto",
                                    padding: "8px"
                                  }}
                                  onClick={() => {
                                    const updatedProducts = values.invoice_product.filter(
                                      (_, i) => i !== index
                                    );

                                    // remove from formik
                                    setFieldValue("invoice_product", updatedProducts, false);

                                    // 🔥 recalculate totals
                                    updateTotals(
                                      updatedProducts,
                                      values.company_gst_type,
                                      values.gst_type,
                                      setFieldValue,
                                      values
                                    );
                                  }}
                                  disabled={values.invoice_product.length === 1}
                                >
                                  <Tooltip title="Remove">
                                    <X size={14} />
                                  </Tooltip>
                                </Button>

                                <Grid container spacing={2} alignItems="flex-end">
                                  <Grid
                                    item
                                    xs={12}
                                    sm={
                                      values?.company_gst_type === 1
                                        ? values?.inclusive_gst == 1
                                          ? 5
                                          : 9
                                        : 12
                                    }
                                  >
                                    <label>Item</label>
                                    <Select
                                      options={productData?.map((item) => ({
                                        label: item?.i_p_name,
                                        value: item?.i_p_id,
                                        i_hsn_code: item?.i_hsn_code,
                                        i_p_price: item?.i_p_price,
                                        i_d_description: item?.i_d_description
                                      }))}
                                      value={
                                        productData
                                          ?.map((item) => ({
                                            label: item?.i_p_name,
                                            value: item?.i_p_id,
                                            i_hsn_code: item?.i_hsn_code,
                                            i_p_price: item?.i_p_price,
                                            i_d_description: item?.i_d_description
                                          }))
                                          .find(
                                            (item) =>
                                              item.value == values.invoice_product[index].i_p_id
                                          ) || null
                                      }
                                      onChange={(selectedOption) => {
                                        const productPrice = Number(selectedOption?.i_p_price || 0);
                                        const inclusive = values.inclusive_gst == 1;

                                        const effectiveTaxType = determineGstType(values.c_company_gst_no, values.state_id, values.gst_type);

                                        const updatedItem = {
                                          ...values.invoice_product[index],
                                          i_p_id: selectedOption ? selectedOption.value : -1,
                                          i_d_hsn_code: selectedOption?.i_hsn_code || "",
                                          i_d_cost: productPrice.toString(),
                                          i_per_pic: inclusive ? productPrice.toString() : "0",
                                          i_d_description: selectedOption?.i_d_description || "",
                                          i_d_p_name: selectedOption?.label || "",
                                          i_d_igst_per:
                                            effectiveTaxType == 1 ? settingData?.i_gst_per || 18 : "0",
                                          i_d_sgst_per:
                                            effectiveTaxType == 2 ? (settingData?.i_gst_per || 18) / 2 : "0",
                                          i_d_cgst_per:
                                            effectiveTaxType == 2 ? (settingData?.i_gst_per || 18) / 2 : "0"
                                        };

                                        setFieldValue(
                                          `invoice_product.${index}`,
                                          updatedItem,
                                          false
                                        );

                                        calculateRow(index, updatedItem, values, setFieldValue);
                                      }}
                                      onBlur={() =>
                                        setFieldTouched(`invoice_product.${index}.i_p_id`, true)
                                      }
                                      menuPortalTarget={document.body}
                                      styles={{
                                        control: (base, state) => ({
                                          ...base,
                                          borderColor:
                                            touched.invoice_product?.[index]?.i_p_id &&
                                              errors.invoice_product?.[index]?.i_p_id
                                              ? "#d32f2f"
                                              : base.borderColor,
                                          boxShadow:
                                            touched.invoice_product?.[index]?.i_p_id &&
                                              errors.invoice_product?.[index]?.i_p_id
                                              ? "0 0 0 1px #d32f2f"
                                              : state.isFocused
                                                ? base.boxShadow
                                                : "none",
                                          "&:hover": {
                                            borderColor:
                                              touched.invoice_product?.[index]?.i_p_id &&
                                                errors.invoice_product?.[index]?.i_p_id
                                                ? "#d32f2f"
                                                : base.borderColor
                                          }
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,

                                          zIndex: 9999
                                        })
                                      }}
                                    />
                                    {touched.invoice_product?.[index]?.i_p_id &&
                                      errors.invoice_product?.[index]?.i_p_id && (
                                        <p
                                          style={{
                                            color: "#d32f2f",
                                            fontSize: "0.75rem",
                                            margin: "3px 0px 0"
                                          }}
                                        >
                                          {errors.invoice_product[index].i_p_id}
                                        </p>
                                      )}
                                  </Grid>
                                  {values?.company_gst_type === 1 && (
                                    <>
                                      <Grid item xs={12} sm={3}>
                                        <Field name={`invoice_product.${index}.i_d_hsn_code`}>
                                          {({ field, form }) => (
                                            <TextField
                                              {...field}
                                              size="small"
                                              label="HSN/SAC Code"
                                              autoComplete="off"
                                              fullWidth
                                              inputProps={{
                                                inputMode: "numeric"
                                              }}
                                              onChange={(e) => {
                                                const value = e.target.value;

                                                if (/^\d*$/.test(value)) {
                                                  form.setFieldValue(field.name, value);
                                                }
                                              }}
                                            />
                                          )}
                                        </Field>
                                      </Grid>
                                    </>
                                  )}

                                  {values?.inclusive_gst == 1 && (
                                    <>
                                      <Grid item xs={12} sm={4}>
                                        <Field name={`invoice_product.${index}.i_per_pic`}>
                                          {({ field, form }) => (
                                            <TextField
                                              {...field}
                                              size="small"
                                              label="Single Product/Service Price Including TAX"
                                              fullWidth
                                              inputProps={{
                                                inputMode: "decimal"
                                              }}
                                              onFocus={() => {
                                                if (field.value === "0.00" || field.value === "0") {
                                                  form.setFieldValue(field.name, "");
                                                }
                                              }}
                                              onChange={(e) => {
                                                const value = e.target.value;

                                                if (!/^\d*(\.\d{0,2})?$/.test(value)) return;

                                                form.setFieldValue(field.name, value);

                                                const item = values.invoice_product[index];
                                                const gst_type = values.gst_type;
                                                const inclusive = values.inclusive_gst == 1;

                                                let cost = Number(value || 0); // ✅ use fresh value

                                                if (inclusive) {
                                                  if (gst_type == 1) {
                                                    const rate = Number(item?.i_d_igst_per || 0);
                                                    cost = (cost * 100) / (100 + rate);
                                                  } else if (gst_type == 2) {
                                                    const sRate = Number(item?.i_d_sgst_per || 0);
                                                    const cRate = Number(item?.i_d_cgst_per || 0);
                                                    const totalRate = sRate + cRate;

                                                    cost = (cost * 100) / (100 + totalRate);
                                                  }
                                                }

                                                const products = [...values.invoice_product];

                                                products[index] = {
                                                  ...products[index],
                                                  i_d_cost: cost?.toFixed(2),
                                                  i_per_pic: value
                                                };

                                                calculateRow(
                                                  index,
                                                  products[index],
                                                  { ...values, invoice_product: products },
                                                  setFieldValue
                                                );
                                              }}
                                              onBlur={() => {
                                                const val = field.value;
                                                form.setFieldValue(
                                                  field.name,
                                                  val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                                );
                                              }}
                                            />
                                          )}
                                        </Field>
                                      </Grid>
                                    </>
                                  )}

                                  <Grid item xs={12} sm={3}>
                                    <Field name={`invoice_product.${index}.i_d_cost`}>
                                      {({ field, form }) => (
                                        <TextField
                                          {...field}
                                          size="small"
                                          label="Cost"
                                          fullWidth
                                          inputProps={{
                                            inputMode: "decimal"
                                          }}
                                          disabled={values?.inclusive_gst == 1}
                                          onFocus={() => {
                                            if (field.value === "0.00" || field.value === "0") {
                                              form.setFieldValue(field.name, "");
                                            }
                                          }}
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                              handleRowChange(
                                                index,
                                                "i_d_cost",
                                                value,
                                                values,
                                                form.setFieldValue
                                              );
                                            }
                                          }}
                                          onBlur={() => {
                                            const val = field.value;
                                            form.setFieldValue(
                                              field.name,
                                              val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                            );
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </Grid>
                                  <Grid item xs={12} sm={3}>
                                    <Field name={`invoice_product.${index}.i_d_qty`}>
                                      {({ field, form }) => (
                                        <TextField
                                          {...field}
                                          size="small"
                                          label="Qty"
                                          fullWidth
                                          inputProps={{
                                            inputMode: "numeric"
                                          }}
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            if (/^\d*$/.test(value)) {
                                              handleRowChange(
                                                index,
                                                "i_d_qty",
                                                value,
                                                values,
                                                form.setFieldValue
                                              );
                                            }
                                          }}
                                          onBlur={() => {
                                            const val = parseInt(field.value || "0", 10);
                                            form.setFieldValue(field.name, val > 0 ? val : 1);
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </Grid>
                                  <Grid item xs={12} sm={3}>
                                    <Field name={`invoice_product.${index}.i_d_discount_amt`}>
                                      {({ field, form }) => (
                                        <TextField
                                          {...field}
                                          size="small"
                                          label="Discount"
                                          fullWidth
                                          inputProps={{
                                            inputMode: "decimal"
                                          }}
                                          onFocus={() => {
                                            if (field.value === "0.00" || field.value === "0") {
                                              form.setFieldValue(field.name, "");
                                            }
                                          }}
                                          onChange={(e) => {
                                            const value = e.target.value;

                                            if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                              handleRowChange(
                                                index,
                                                "i_d_discount_amt",
                                                value,
                                                values,
                                                form.setFieldValue
                                              );
                                            }
                                          }}
                                          onBlur={() => {
                                            const val = field.value;
                                            form.setFieldValue(
                                              field.name,
                                              val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                            );
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </Grid>
                                  <Grid item xs={12} sm={3}>
                                    <Field name={`invoice_product.${index}.i_d_sub_amt`}>
                                      {({ field, form }) => (
                                        <TextField
                                          {...field}
                                          size="small"
                                          label="Sub Total"
                                          fullWidth
                                          disabled
                                          inputProps={{
                                            inputMode: "decimal"
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </Grid>
                                  {values?.company_gst_type === 1 && (
                                    <>
                                      {(determineGstType(values.c_company_gst_no, values.state_id, values.gst_type) == 1) && (
                                        <Grid item xs={12} sm={4}>
                                          <Field name={`invoice_product.${index}.i_d_igst_per`}>
                                            {({ field, form }) => (
                                              <TextField
                                                {...field}
                                                size="small"
                                                label="IGST"
                                                fullWidth
                                                inputProps={{
                                                  inputMode: "decimal"
                                                }}
                                                onFocus={() => {
                                                  if (field.value === "0.00" || field.value === "0") {
                                                    form.setFieldValue(field.name, "");
                                                  }
                                                }}
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                    handleRowChange(
                                                      index,
                                                      "i_d_igst_per",
                                                      value,
                                                      values,
                                                      form.setFieldValue
                                                    );
                                                  }
                                                }}
                                                onBlur={() => {
                                                  const val = field.value;
                                                  form.setFieldValue(
                                                    field.name,
                                                    val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                                  );
                                                }}
                                              />
                                            )}
                                          </Field>
                                        </Grid>
                                      )}

                                      {(determineGstType(values.c_company_gst_no, values.state_id, values.gst_type) == 2) && (
                                        <>
                                          <Grid item xs={12} sm={3}>
                                            <Field name={`invoice_product.${index}.i_d_sgst_per`}>
                                              {({ field, form }) => (
                                                <TextField
                                                  {...field}
                                                  size="small"
                                                  label="SGST"
                                                  fullWidth
                                                  inputProps={{
                                                    inputMode: "decimal"
                                                  }}
                                                  onFocus={() => {
                                                    if (field.value === "0.00" || field.value === "0") {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  onChange={(e) => {
                                                    const value = e.target.value;

                                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                      handleRowChange(
                                                        index,
                                                        "i_d_sgst_per",
                                                        value,
                                                        values,
                                                        form.setFieldValue
                                                      );
                                                    }
                                                  }}
                                                  onBlur={() => {
                                                    const val = field.value;
                                                    form.setFieldValue(
                                                      field.name,
                                                      val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                                    );
                                                  }}
                                                />
                                              )}
                                            </Field>
                                          </Grid>
                                          <Grid item xs={12} sm={3}>
                                            <Field name={`invoice_product.${index}.i_d_cgst_per`}>
                                              {({ field, form }) => (
                                                <TextField
                                                  {...field}
                                                  size="small"
                                                  label="CGST"
                                                  fullWidth
                                                  inputProps={{
                                                    inputMode: "decimal"
                                                  }}
                                                  onFocus={() => {
                                                    if (field.value === "0.00" || field.value === "0") {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  onChange={(e) => {
                                                    const value = e.target.value;

                                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                                      handleRowChange(
                                                        index,
                                                        "i_d_cgst_per",
                                                        value,
                                                        values,
                                                        form.setFieldValue
                                                      );
                                                    }
                                                  }}
                                                  onBlur={() => {
                                                    const val = field.value;
                                                    form.setFieldValue(
                                                      field.name,
                                                      val && !isNaN(val) ? Number(val).toFixed(2) : "0"
                                                    );
                                                  }}
                                                />
                                              )}
                                            </Field>
                                          </Grid>
                                        </>
                                      )}

                                      <Grid
                                        item
                                        xs={12}
                                        sm={3}
                                      >
                                        <Field name={`invoice_product.${index}.tax_amount`}>
                                          {({ field, form }) => (
                                            <TextField
                                              {...field}
                                              value={
                                                location?.state?.mode === "edit"
                                                  ? calculateTaxTotal(
                                                    values?.invoice_product?.[index]
                                                  )
                                                  : field.value ?? 0
                                              }
                                              size="small"
                                              label="Tax Amount"
                                              fullWidth
                                              disabled
                                              inputProps={{
                                                inputMode: "decimal"
                                              }}
                                            />
                                          )}
                                        </Field>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={12}
                                        sm={3}
                                      >
                                        <Field name={`invoice_product.${index}.i_d_total_amt`}>
                                          {({ field, form }) => (
                                            <TextField
                                              {...field}
                                              size="small"
                                              label="Total Amount"
                                              fullWidth
                                              disabled
                                              inputProps={{
                                                inputMode: "decimal"
                                              }}
                                            />
                                          )}
                                        </Field>
                                      </Grid>
                                    </>
                                  )}

                                  <Grid item xs={12}>
                                    <Field name={`invoice_product.${index}.i_d_description`}>
                                      {({ field, form }) => (
                                        <TextField
                                          {...field}
                                          size="small"
                                          label="Comments"
                                          autoComplete="off"
                                          fullWidth
                                          multiline
                                          rows={3}
                                          onBlur={(e) => {
                                            form.setFieldValue(field.name, field.value.trim());
                                            field.onBlur(e);
                                          }}
                                        />
                                      )}
                                    </Field>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Stack>
                          </>
                        ))}

                        <Grid container spacing={5}>
                          <Grid item xs={12}>
                            <Button
                              onClick={() =>
                                push({
                                  i_p_id: "",
                                  i_d_hsn_code: "",
                                  i_per_pic: "0",
                                  i_d_qty: "1",
                                  i_d_cost: "0",
                                  i_d_discount_amt: "0",
                                  i_d_sub_amt: "0",
                                  tax_amount: "0",
                                  i_d_total_amt: "0",
                                  i_d_description: "",
                                  i_d_igst_per:
                                    formikRef?.current?.values?.gst_type == 1
                                      ? settingData?.i_gst_per || 18
                                      : "0",
                                  i_d_sgst_per:
                                    formikRef?.current?.values?.gst_type == 2
                                      ? Number(settingData?.i_gst_per || 18) / 2
                                      : "0",
                                  i_d_cgst_per:
                                    formikRef?.current?.values?.gst_type == 2
                                      ? Number(settingData?.i_gst_per || 18) / 2
                                      : "0"
                                })
                              }
                              style={{ marginRight: "10px" }}
                              variant="contained"
                            >
                              Add Item
                            </Button>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </FieldArray>

                  <hr style={{ margin: "25px 0" }} />
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={6}>
                      {location?.state?.data?.i_type == 1 && (
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle1"
                              fontWeight={700}
                              sx={{ marginBottom: "25px" }}
                            >
                              Invoice type
                            </Typography>
                          </Grid>

                          <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <DatePicker
                                name="payment_date"
                                label="Payment Date"
                                inputFormat="dd/MM/yyyy"
                                value={values.payment_date ? new Date(values.payment_date) : null}
                                onChange={(newDate) => {
                                  setFieldValue("payment_date", newDate || null);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} size="small" fullWidth />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={12}>
                            <label>Accept Payments Via</label>

                            <Select
                              options={paymentMethodsList?.map((paym) => ({
                                label: paym?.method_name,
                                value: paym?.p_m_id
                              }))}
                              value={
                                paymentMethodsList
                                  ?.map((paym) => ({
                                    label: paym?.method_name,
                                    value: paym?.p_m_id
                                  }))
                                  ?.find((option) => option.value == values.p_m_id) || null
                              }
                              onChange={(selectedOption) =>
                                setFieldValue("p_m_id", selectedOption ? selectedOption.value : -1)
                              }
                              onBlur={() => setFieldTouched("p_m_id", true)}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                control: (base) => ({
                                  ...base,
                                  borderColor:
                                    touched.p_m_id && errors.p_m_id ? "#d32f2f" : base.borderColor
                                })
                              }}
                            />
                            {touched.p_m_id && errors.p_m_id && (
                              <p
                                style={{
                                  color: "#d32f2f",
                                  fontSize: "0.75rem",
                                  margin: "3px 0px 0"
                                }}
                              >
                                {errors.p_m_id}
                              </p>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <Field name={`payment_amount`}>
                              {({ field, form }) => (
                                <TextField
                                  {...field}
                                  size="small"
                                  label="Payment Amount"
                                  fullWidth
                                  inputProps={{
                                    inputMode: "decimal"
                                  }}
                                  defaultValue={0 || values?.i_total_amt}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (/^\d*(\.\d{0,2})?$/.test(value)) {
                                      form.setFieldValue(field.name, value);
                                    }
                                  }}
                                  onBlur={() => {
                                    const val = field.value;
                                    if (val !== "" && val !== null) {
                                      form.setFieldValue(field.name, Number(val).toFixed(2));
                                    }
                                  }}
                                  disabled
                                />
                              )}
                            </Field>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div>
                          <div style={{ display: "flex", gap: "35px" }}>
                            <p>Subtotal: </p>
                            <p>₹ {values?.i_subtotal_amt}</p>
                          </div>
                          <div style={{ display: "flex", gap: "34px" }}>
                            <p>Discount: </p>
                            <p>₹ {values?.i_discount_amt}</p>
                          </div>
                          {values.company_gst_type === 1 && (
                            <>
                              {determineGstType(values.c_company_gst_no, values.state_id, values.gst_type) == 1 && (
                                <div style={{ display: "flex", gap: "63px" }}>
                                  <p>IGST: </p>
                                  <p>₹ {values?.i_igst_amt}</p>
                                </div>
                              )}
                              {determineGstType(values.c_company_gst_no, values.state_id, values.gst_type) == 2 && (
                                <>
                                  <div style={{ display: "flex", gap: "57px" }}>
                                    <p>SGST: </p>
                                    <p>₹ {values?.i_sgst_amt}</p>
                                  </div>
                                  <div style={{ display: "flex", gap: "57px" }}>
                                    <p>CGST: </p>
                                    <p>₹ {values?.i_cgst_amt}</p>
                                  </div>
                                </>
                              )}
                            </>
                          )}

                          <hr style={{ margin: "10px 0" }} />
                          <div style={{ display: "flex", gap: "64px" }}>
                            <p>Total:</p>
                            <p>₹ {values?.i_total_amt}</p>
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}
                      >
                        <div>
                          <Box
                            sx={{
                              width: 140,
                              height: 150,
                              border: "1px dashed #ccc",
                              borderRadius: 2,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              overflow: "hidden",
                              backgroundColor: "#fafafa",
                              boxShadow: 1,
                              p: 1
                            }}
                          >
                            {(values?.company_gst_type == 0 && settingData?.i_ngst_sign) ||
                              (values?.company_gst_type != 0 && settingData?.i_gst_sign) ? (
                              <img
                                src={`${Routes.API_HOSTNAME}invoice-setting/${values?.company_gst_type == 0 ? settingData?.i_ngst_sign : settingData?.i_gst_sign}`}
                                alt="No Signature"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain"
                                }}
                              />
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                No Logo
                              </Typography>
                            )}
                          </Box>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <hr style={{ margin: "25px 0" }} />
                  <Grid container spacing={5}>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        size="small"
                        label="Terms & Conditions"
                        name="i_t_c"
                        autoComplete="off"
                        fullWidth
                        multiline
                        rows={3}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        as={TextField}
                        size="small"
                        label="Remarks"
                        name="remarks"
                        autoComplete="off"
                        fullWidth
                        multiline
                        rows={3}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end"
                      }}
                    >
                      <Button
                        style={{ marginRight: "10px" }}
                        variant="contained"
                        type="submit"
                        disabled={loading}
                      >
                        Generate
                        {loading && (
                          <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                        )}
                      </Button>
                      {location?.state?.mode == "edit" && (
                        <Button
                          variant="contained"
                          onClick={() => {
                            handleDownload(
                              `${Routes.API_HOSTNAME}invoice-pdf/${location?.state?.data?.i_file_name}`,
                              location?.state?.data?.i_file_name
                            );
                          }}
                        >
                          Download
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Form>
              </>
            );
            }}
          </Formik>
        </Card>
      </Page>
      {customerModal && (
        <CustomerInsertUpdateModal
          addEditModal={customerModal}
          setAddEditModal={setCustomerModal}
          toggleAddEditModal={toggleCustomerModal}
          getCustomerListForInvoice={getCustomerListForInvoice}
        />
      )}
    </>
  );
}
